export const cardsQuestions = {
  cards: {
    header: 'applicationForm.CARDS.note',
    empty: 'applicationForm.CARDS.noCards',
    add: 'applicationForm.CARDS.addCard',
  },
};
